import { TokenAnalysisData, TokenAnalysisRequest, QueueTokenAnalysisRequest } from '@crypto-trading/common/browser';
import { ApiClientManager } from '@/utils/api-client-factory';

/**
 * Token Analysis API functions
 */
export const getTokenAnalysis = async (
  tokenName: string,
  params?: TokenAnalysisRequest
): Promise<TokenAnalysisData | null> => {
  const tokenAnalysis = await ApiClientManager.getTokenAnalysisClient().getTokenAnalysis(tokenName, params);
  console.log('tokenAnalysis', tokenAnalysis);
  return tokenAnalysis;
};

export const queueTokenAnalysis = async (
  payload: QueueTokenAnalysisRequest
): Promise<{ queued: boolean }> => {
  return ApiClientManager.getTokenAnalysisClient().queueTokenAnalysis(payload);
};


